module.exports = __webpack_public_path__ + "static/spiral-sm-5243eeef5f9ad024cae2ff89d48452ae.png";